import React, { useMemo } from "react";

import { ClickAwayListener, useMediaQuery } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import styles from "./index.module.scss";

export const tooltipSizes = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
  xl: styles.xl,
  xxl: styles.xxl,
  xxxl: styles.xxxl,
};

const Tooltip_ = props => {
  const isMobile = useMediaQuery("(max-width:950px)");
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    if (isMobile) {
      setOpen(true);
    }
  };

  const handleMouseEnter = () => {
    if (!isMobile) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setOpen(false);
    }
  };

  // Автоматически подстраивает ширину подсказки в зависимости от контента
  const size = useMemo(() => {
    if (props.size && props.title) return props.size;
    const length = getReactTextLength(props.title);
    if (length > 180) return tooltipSizes.md;
    return null;
  }, [props.size, props.title]);
  //

  return props.title ? (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div
        style={{
          display: "inline-block",
          width: props.width || "max-content",
          ...(props.style || {}),
        }}>
        <Tooltip
          onClose={handleTooltipClose}
          open={open}
          arrow
          enterDelay={100}
          enterNextDelay={100}
          disableInteractive={isMobile ? false : true}
          disableHoverListener={isMobile ? true : false}
          disableFocusListener={isMobile ? true : false}
          disableTouchListener={isMobile ? true : false}
          slotProps={{
            popper: {
              disablePortal: isMobile ? true : false,
              sx: { zIndex: 1000000 },
            },
          }}
          classes={{
            // tooltip: `${styles.root} ${props.dark ? styles.dark : ""} ${props.size}`,
            tooltip: `${styles.root} ${props.dark ? styles.dark : ""} ${size}`,
            arrow: `${styles.arrow} ${props.dark ? styles.dark : ""}`,
          }}
          {...props}
          placement={props.placement ?? "top"}>
          <span
            onClick={handleTooltipOpen}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            {props.children}
          </span>
        </Tooltip>
      </div>
    </ClickAwayListener>
  ) : (
    props.children
  );
};

export default Tooltip_;

function getReactTextLength(element) {
  if (element == null) return 0;
  if (typeof element === "string" || typeof element === "number") return String(element).length;
  // Массив дочерних элементов
  if (Array.isArray(element))
    return element.reduce((sum, child) => sum + getReactTextLength(child), 0);
  // React-элемент (проверяем по структуре)
  if (element.props && element.props.children !== undefined)
    return getReactTextLength(element.props.children);
  return null;
}
